import "@shoelace-style/shoelace/dist/components/button/button.js";
import React from "react";

/**
 * BoardActions - Actions for the kanban board
 *
 * @param {Object} props
 * @param {boolean} props.showArchived - Whether archived items are shown
 * @param {Function} props.onToggleArchived - Handler for toggling archived visibility
 * @param {Function} props.onArchiveAllDone - Handler for archiving all done tasks
 * @param {Function} props.onDeleteAllArchived - Handler for deleting all archived tasks
 * @param {Object} props.taskCounts - Counts of tasks by status
 * @param {boolean} props.isArchiving - Whether archiving operation is in progress
 */
const BoardActions = ({
  showArchived,
  onToggleArchived,
  onArchiveAllDone,
  onDeleteAllArchived,
  taskCounts,
  isArchiving = false,
}) => {
  return (
    <div className="flex space-x-2">
      <sl-button
        variant="neutral"
        size="small"
        onClick={onToggleArchived}
        data-shortcut="a"
      >
        {showArchived ? "Hide Archived" : "Show Archived"}
      </sl-button>

      {taskCounts["Done"] > 0 && (
        <sl-button
          variant="primary"
          size="small"
          onClick={onArchiveAllDone}
          disabled={isArchiving}
          data-shortcut="d"
        >
          {isArchiving
            ? "Archiving..."
            : `Archive Done (${taskCounts["Done"]})`}
        </sl-button>
      )}

      {showArchived && taskCounts["Archived"] > 0 && (
        <sl-button variant="danger" size="small" onClick={onDeleteAllArchived}>
          Delete All Archived
        </sl-button>
      )}
    </div>
  );
};

export default BoardActions;
